<template>
  <div class="c-app">
    <loading :active.sync="isLoading" 
        :can-cancel="true"
        background-color = "#000"
         
        >
    </loading>

    <TheSidebar/>
    <div class="c-wrapper">
      <TheHeader v-bind:class="{'d-none':this.profile.isRASPI }"/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter v-bind:class="{'d-none':this.profile.isRASPI }"/>
    </div>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import Vue from "vue";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
// Init loading plugin
Vue.use(Loading); 

import { mapGetters, mapActions } from "vuex";

export default {
  name: 'TheContainer',
  computed : mapGetters(["isLoading","profile"]),
  components: {
    Loading,
    TheSidebar,
    TheHeader,
    TheFooter
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
